import React from "react";
function CookiePolicy () {

    return <h3>CookiePolicy Under development</h3>
}
export default CookiePolicy;